// If a dictionary value is an array type, add entry to the value at key
export const addToDictArrayValue = (dict, key, entry) => {
    if (dict[key]) {
        dict[key].push(entry);
    }
    else {
        dict[key] = [entry];
    }
};
